import React, { useCallback, useContext, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import { TextInputProps } from './types';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';
import Input from '../Input/Input';

const TextInput: React.FC<TextInputProps> = (props) => {
  const {
    input,
    meta,
    placeholder,
    label,
    textType = 'text',
    readOnly,
    disabled,
    testId,
    size,
    variant = 'underline',
    helperText,
    showClearIcon,
    iconComponent,
    pattern,
    value,
    maxLength,
    onChange,
    onBlur,
    onFocus,
    onMouseDown,
    onKeyDown,
  } = props;
  const { actualTheme } = useContext(ThemeContext);

  const inputValue = useMemo(() => value ?? input.value, [input.value, value]);

  const handleChange = useCallback(
    (newValue: string) => {
      const patt = new RegExp(pattern);
      const isOneCharShorter = newValue.length === inputValue.length - 1;
      const isAlmostEqual = isOneCharShorter && inputValue.indexOf(newValue) === 0;
      if (patt.test(newValue) || isAlmostEqual) {
        if (input) input.onChange(newValue);
        if (onChange) onChange(newValue);
      }
    },
    [pattern, inputValue, input, onChange],
  );

  const handleClear = useCallback(() => {
    if (input) input.onChange('');
    if (onChange) onChange('');
  }, [input, onChange]);

  return (
    <ThemeProvider theme={actualTheme}>
      <Input
        testId={testId}
        label={label}
        readOnly={readOnly || disabled}
        disabled={disabled}
        value={inputValue}
        type={textType}
        input={input}
        meta={meta}
        autoComplete="off"
        size={size}
        variant={variant}
        helperText={helperText}
        showClearIcon={showClearIcon}
        placeholder={placeholder}
        onChange={handleChange}
        onClear={handleClear}
        rightAddOn={iconComponent}
        onBlur={onBlur}
        onFocus={onFocus}
        onMouseDown={onMouseDown}
        maxLength={maxLength}
        onKeyDown={onKeyDown}
      />
    </ThemeProvider>
  );
};

export default TextInput;
